import React from "react"
import { ProcessSelector } from "./components/processSelector"
import { PhotoTips } from "./components/photoTips"
import { UploadComment } from "./components/uploadComment"
import { Footer } from "./components/footer"
import { DataMessage } from "./components/dataMessage"
import { connect } from "react-redux"
import { recordLinkV2 } from "utilities/tagging"
import { UPLOAD_DOCUMENTATION } from "constants/tagging"
import "./uploadProcess.scss"
import {
    saveProcessSelected,
    increaseDocumentsUploaded,
    resetProcessSelected,
} from "actions/myProfileUploadDocumentation"
import PropTypes from "prop-types"
import { uploadDocumentationToDms } from "actions/UploadDocumentationActions"
import { DOCUMENTATION_UPLOAD_PROCESS_SUCCESS_URL } from "constants/index"
import { translateText } from "../../getTranslationsMyProfileUploadDocumentation"
import { UploadTips } from "./components/UploadTips"
import { ERROR_TYPE, FileBox, SUCCESS_TYPE } from "./components/fileBox/FileBox"
import { UploadedFileContent } from "./components/fileBox/UploadedFileContent"
import { FileUploadLimit } from "./components/fileUploadLimit"
import { ErrorMessage } from "./components/errorMessage"
import { DragNDropUpload } from "./components/dragNDropUpload/DragNDropUpload"
import { OTHER_OPTION_ID } from "./components/getProcessOptions"
import { WarningMessage } from "./components/warningMessage"
import { MAX_FILES, VALID_TYPES_FILE } from "../../constants/constants"
import { withRouter } from "react-router-dom"
import { ErrorWillNotBeAttached } from "./components/ErrorWillNotBeAttached"

const INITIAL_STATE = {
    uploadComment: "",
    uploadedFiles: [],
    isUploadingDocument: false,
    showUploadFileBox: true,
    showFileLimitAdvise: false,
    showUploadFileError: false,
}

class UploadProcess extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ...INITIAL_STATE,
            processSelected: Object.keys(this.props.myProfileUploadDocumentation.get("processSelected").toJS()).length === 0 ? "" : this.props.myProfileUploadDocumentation.get("processSelected").toJS(),
        }
        this.handleOnErrorUploadDocument = this.handleOnErrorUploadDocument.bind(this)
    }

    componentWillUnmount() {
        this.props.resetProcessSelected()
    }

    recordEvent = extraData => {
        const { processSelected: { label } } = this.state

        const dataToRecord = {
            categoriaEvento: `${UPLOAD_DOCUMENTATION}/${label}`,
            ...extraData,
        }

        recordLinkV2(dataToRecord)
    }

    triggerLimitFileAdvise = () => {
        this.setState({ showFileLimitAdvise: true }, () => {
            setTimeout(() => {
                this.setState({ showFileLimitAdvise: false })
            }, 5000)
        })
    }

    handleOnChangeFile = uploadedFiles => {
        uploadedFiles.forEach((file, index) => {
            if (this.state.uploadedFiles.length + index > MAX_FILES) return;

            !file.validationError && this.recordEvent({
                accionEvento: `subir archivo ${this.state.uploadedFiles.length + index}`,
                etiquetaEvento: "exito",
            })
        })

        if (uploadedFiles.length > MAX_FILES) {
            this.triggerLimitFileAdvise()
        }

        const filesToSave = [...this.state.uploadedFiles, ...uploadedFiles]

        this.setState({
            uploadedFiles: [...filesToSave].slice(0, MAX_FILES),
        })
    }

    handleOnRemoveFile = (idFile, index) => {
        const { uploadedFiles } = this.state

        this.setState({
            uploadedFiles: uploadedFiles.filter(file => file.id !== idFile),
        })

        this.recordEvent({
            accionEvento: `eliminar archivo ${index}`,
        })
    }

    handleProcessSelected = (processSelected) => {
        this.resetUploadProcess()
        this.setState({ processSelected }, () => {
            this.recordEvent({
                accionEvento: "inicio",
            })
        })
    }

    handleChangeUploadComment = (value) => {
        this.setState({ uploadComment: value })
    }

    handleOnFocusComment = () => {
        this.recordEvent({
            accionEvento: "anotacion",
        })
    }

    handleClickUploadFile = () => {
        this.recordEvent({
            accionEvento: "subir archivo 1/desde tus archivos",
            etiquetaEvento: "inicio",
        })
    }

    handleOnExit = () => {
        this.recordEvent({
            accionEvento: "cancelar",
        })
    }

    handleOnFinishUploadDocument = () => {
        const { history, increaseDocumentsUploaded } = this.props
        increaseDocumentsUploaded()
        history.push(DOCUMENTATION_UPLOAD_PROCESS_SUCCESS_URL)
    }

    handleOnErrorUploadDocument = () => {
        recordLinkV2({
            categoriaEvento: `documentos/subida de documentacion/${this.state.processSelected.label}`,
            accionEvento: `subir archivo ${this.state.uploadedFiles.length}}`,
            categoriaError: `error en subida de documentacion/${this.state.processSelected.label}`,
            descripcionError: "error al intentar adjuntar los archivos"
        })

        this.setState({ showUploadFileError: true })
    }

    handleOnContinue = () => {
        const { processSelected, uploadedFiles, uploadComment } = this.state
        const { saveProcessSelected, uploadDocumentationToDms, profile } = this.props

        this.recordEvent({
            categoriaEvento: `documentos/subida de documentacion/${processSelected.label}`,
            accionEvento: `subir archivo ${uploadedFiles.length}`,
            etiquetaEvento: "adjuntar",
        })

        saveProcessSelected(processSelected)

        if (!uploadedFiles.length || this.someFileError())  return;

        this.setState({
            isUploadingDocument: true,
            showUploadFileError: false,
        })

        uploadDocumentationToDms({
            uploadedFiles,
            customerId: profile.get("customerId"),
            additionalInfo: uploadComment,
            documentType: processSelected.value,
            confidential: processSelected.confidential,
            processLabel: processSelected.label,
            finishCallback: this.handleOnFinishUploadDocument,
            errorCallback: this.handleOnErrorUploadDocument,
            countryCode: profile.get("originCountry"),
        })
    }

    resetUploadProcess = () => {
        this.setState({ ...INITIAL_STATE })
        this.resetFileBox()
    }

    resetFileBox = () => {
        this.setState({
            showUploadFileBox: false,
        }, () => {
            this.setState({ showUploadFileBox: true })
        })
    }

    someFileError = () => this.state.uploadedFiles.some(file => file.validationError);

    howManyFilesWithError = () => {
        return this.state.uploadedFiles.filter(file => file.validationError).length
    }

    isContinueDisabled = () => {
        const { uploadedFiles, isUploadingDocument } = this.state
        return !uploadedFiles.length || isUploadingDocument || this.someFileError()
    }

    render() {
        const {
            processSelected,
            uploadComment,
            uploadedFiles,
            isUploadingDocument,
            showUploadFileBox,
            showFileLimitAdvise,
            showUploadFileError,
        } = this.state
        const { profile } = this.props

        return (
            <div className="process-container">
                <div className={"title-container"}>
                    <h4 className="main-title">{translateText("boxTitle")}</h4>
                </div>
                <ProcessSelector
                    value={processSelected}
                    onChange={this.handleProcessSelected}
                    originCountry={profile.get("originCountry")}
                />
                {processSelected && (
                    <React.Fragment>
                        {processSelected.value === OTHER_OPTION_ID && <WarningMessage />}
                        <UploadTips />
                        <PhotoTips processSelected={processSelected.label}/>
                        <div className="upload-files__container">
                            {uploadedFiles.map(({ file: { name }, validationError, id }, index) => {
                                return (
                                    <FileBox
                                        key={id}
                                        type={validationError ? ERROR_TYPE : SUCCESS_TYPE}
                                        errorMessage={validationError}
                                    >
                                        <UploadedFileContent
                                            name={name}
                                            errorMessage={validationError}
                                            onDelete={() => this.handleOnRemoveFile(id, index)}
                                        />
                                    </FileBox>
                                )
                            })}
                            {showUploadFileBox && uploadedFiles.length < MAX_FILES &&
                                <div className="file-uploader__container" onClick={this.handleClickUploadFile}>
                                    <DragNDropUpload
                                        idName={"process-file-upload"}
                                        onChange={this.handleOnChangeFile}
                                        validTypes={VALID_TYPES_FILE}
                                    />
                                </div>
                            }
                            {this.someFileError() && <ErrorWillNotBeAttached filesWithErrors={this.howManyFilesWithError()} processSelected={processSelected.label}/>}
                        </div>
                        <UploadComment
                            value={uploadComment}
                            onChange={this.handleChangeUploadComment}
                            onFocus={this.handleOnFocusComment}
                        />
                        <DataMessage />
                        {showUploadFileError && <ErrorMessage message={translateText("errorUploadingDocuments")} />}
                        <Footer
                            isContinueDisabled={this.isContinueDisabled()}
                            onContinue={this.handleOnContinue}
                            onExit={this.handleOnExit}
                            isLoading={isUploadingDocument}
                        />
                    </React.Fragment>
                )}
                {showFileLimitAdvise && <FileUploadLimit processSelected={processSelected.label}/>}
            </div>
        )
    }
}

UploadProcess.propTypes = {
    uploadDocumentationToDms: PropTypes.func,
    profile: PropTypes.object,
    myProfileUploadDocumentation: PropTypes.object,
    history: PropTypes.object.isRequired,
    saveProcessSelected: PropTypes.func,
    increaseDocumentsUploaded: PropTypes.func,
    resetProcessSelected: PropTypes.func,
}
module.exports.UploadProcess = connect(state => ({
    profile: state.profile,
    myProfileUploadDocumentation: state.myProfileUploadDocumentation,
}), {
    uploadDocumentationToDms,
    saveProcessSelected,
    increaseDocumentsUploaded,
    resetProcessSelected,
})(withRouter(UploadProcess))
